import { useNavigate } from "react-router-dom";
//import * as olSource from "ol/source";
import { Map as MapObject } from "ol";
import { transform } from "ol/proj";
import RGL, { Layout, WidthProvider } from "react-grid-layout";
import NavBar from "../components/navbar/NavBar";
import GridWindow from "../components/common/GridWindow";
import WindowIds from "../models/layout/windowIds";
import { useEffect, useRef, useState } from "react";
import ProjectInfo from "../models/projectInfo";
import MapControl, {
  MapControlRef,
} from "../components/map/controls/MapControl";
import Controls from "../components/map/controls/Controls";
import FullScreenControl from "../components/map/controls/FullScreenControl";
import Layers from "../components/map/layers/Layers";
import TileLayer from "../components/map/layers/TileLayer";
import osm from "../components/map/source/osm";
import xyz from "../components/map/source/xyz";
import ProjectCollectionInfo from "../models/projectCollectionInfo";
import projectService from "../services/projectService";
import localStorageService from "../services/localStorageService";

const ReactGridLayout = WidthProvider(RGL);

const HomeAirport: React.FC = () => {
  const mapControlRef = useRef<MapControlRef>(null);

  const [projectCollection, setProjectCollection] =
    useState<ProjectCollectionInfo>(new ProjectCollectionInfo());

  const [imageTileLayer1, setImageTileLayer1] = useState<any>();
  const [imageTileLayer2, setImageTileLayer2] = useState<any>();
  const [baseLayer, setBaseLayer] = useState<any>();
  const [zoom, setZoom] = useState(0);
  const [center, setCenter] = useState<number[]>([]);
  const [layout, setLayout] = useState<Layout[]>([]);

  const containerRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  useEffect(() => {
    setBaseLayer(osm());

    // const imageTileLayerSource1 = new olSource.XYZ({
    //   tileUrlFunction: function (tileCoord, pixelRatio, projection) {
    //     if (tileCoord === null) {
    //       return undefined;
    //     }

    //     var z = tileCoord[0];
    //     var x = tileCoord[1];
    //     var y = tileCoord[2];
    //     const url = `https://imsconnectprocessing.blob.core.windows.net/dfw-d01-airside-2024-50724/TileSets/${z}/${x}/${y}.png`;
    //     return url;
    //   },
    //   tileSize: 256,
    //   minZoom: 0,
    //   maxZoom: 26,
    // });

    const imageTileLayerSource1 = xyz({
      url: "https://imsconnectprocessing.blob.core.windows.net/dfw-d01-airside-2024-50724/TileSets/{z}/{x}/{y}.png",
      maxZoom: 26,
    });

    setImageTileLayer1(imageTileLayerSource1);

    // const imageTileLayerSource2 = new olSource.XYZ({
    //   tileUrlFunction: function (tileCoord, pixelRatio, projection) {
    //     if (tileCoord === null) {
    //       return undefined;
    //     }

    //     var z = tileCoord[0];
    //     var x = tileCoord[1];
    //     var y = tileCoord[2];
    //     const url = `https://imsconnectprocessing.blob.core.windows.net/dfw-d06-parkhill-2025-50842/TILES/${z}/${x}/${y}.png`;
    //     return url;
    //   },
    //   tileSize: 256,
    //   minZoom: 0,
    //   maxZoom: 26,
    // });

    const imageTileLayerSource2 = xyz({
      url: "https://imsconnectprocessing.blob.core.windows.net/dfw-d06-parkhill-2025-50842/TILES/{z}/{x}/{y}.png",
      maxZoom: 26,
    });
    setImageTileLayer2(imageTileLayerSource2);

    const lonLatPosition = [3878542.9655617615, 32.89910663257858];
    setCenter(lonLatPosition);
    setZoom(14.4);

    const defaultVisible: Layout[] = [];
    defaultVisible.push({ x: 0, y: 0, w: 12, h: 5, i: WindowIds.MapId });
    setLayout(defaultVisible);

    const init = async () => {
      let projectCollection: ProjectCollectionInfo | undefined = undefined;
      let project: ProjectInfo | undefined = undefined;

      const { data: projectCollections } =
        await projectService.getProjectCollectionsInfos();

      const projectCode = "dfwairportcollection";

      let projectCodeFound = false;

      for (const projectCollection of projectCollections) {
        if (
          projectCollection.projects.find((p) => p.projectCode === projectCode)
        ) {
          projectCodeFound = true;
          break;
        }
      }

      if (!projectCodeFound) {
        navigate("/projects");
        return;
      }

      let idProjectCollection = localStorageService.getIdProjectCollection();

      if (!idProjectCollection) {
        navigate("/projects");
        return;
      }

      const prjCollection = projectCollections.find(
        (c) => c.idProjectCollection === idProjectCollection,
      );

      if (!prjCollection || prjCollection.projects.length === 0) {
        navigate("/projects");
        return;
      }

      projectCollection = prjCollection;

      let idProject = localStorageService.getIdProject();
      if (idProject) {
        project = prjCollection.projects.find((p) => p.idProject === idProject);
      }

      if (!project) {
        project = prjCollection.projects[0];
        localStorageService.setIdProject(project.idProject);
      }

      if (!projectCollection || !project) {
        return;
      }

      setProjectCollection(projectCollection);
      //setProject(project);
    };

    init();
  }, [navigate]);

  const onLayoutChanged = (layout: Layout[]) => {
    //console.log("layout:onLayoutChanged", layout);
  };

  const onMapClick = async (evt: any) => {
    const lonlat = transform(evt.coordinate, "EPSG:3857", "EPSG:4326");

    const map = evt.map as MapObject;
    const zoom = map.getView().getZoom();
    const zoomLevel = Math.round(zoom ?? 0);

    console.log("MapClick lonlat, zoomLevel", lonlat, zoomLevel);
  };

  const onChangeBasemap = (event: any) => {
    const layerType = event.target.value;

    if (layerType === "osm") {
      setBaseLayer(osm());
    }

    if (layerType === "aerial") {
      const xyzLayer = xyz({
        url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        maxZoom: 19,
      });
      setBaseLayer(xyzLayer);
    }

    if (layerType === "none") {
      setBaseLayer(undefined);
    }
  };

  return (
    <>
      <NavBar
        underLogoContent={
          <>
            {/* hidden div to make the position abosolute from below to occupy/allocate space on y axis so when text is large to move items to the right */}
            <div
              style={{
                visibility: "hidden",
                marginTop: "-25px",
                marginLeft: "3px",
                fontSize: "10px",
                fontWeight: "bold",
                textWrap: "nowrap",
              }}
            >
              {projectCollection.collectionName}
            </div>
            <div
              style={{
                position: "absolute",
                bottom: "-3px",
                fontSize: "10px",
                fontWeight: "bold",
              }}
            >
              {projectCollection.collectionName}
            </div>
          </>
        }
      />
      <div id="content">
        <ReactGridLayout
          className="layout"
          layout={layout}
          cols={12}
          rowHeight={200}
          draggableHandle=".grid-window-title"
          onLayoutChange={onLayoutChanged}
          margin={[10, 10]}
          useCSSTransforms={false}
        >
          <div key={WindowIds.MapId}>
            <GridWindow
              windowId={WindowIds.MapId}
              title="Map"
              onClose={(windowId: string) => {}}
            >
              <div ref={containerRef}>
                <MapControl
                  ref={mapControlRef}
                  center={center}
                  zoom={zoom}
                  onClick={onMapClick}
                  onPointerMove={() => {}}
                >
                  <Layers>
                    <TileLayer source={baseLayer} zIndex={0} />
                    <TileLayer source={imageTileLayer1} zIndex={1} />
                    <TileLayer source={imageTileLayer2} zIndex={1} />
                  </Layers>
                  <Controls>
                    <FullScreenControl />
                  </Controls>
                </MapControl>
                <div
                  style={{ position: "absolute", top: "6px", right: "40px" }}
                >
                  <select
                    style={{ padding: "2px 4px" }}
                    onChange={onChangeBasemap}
                  >
                    <option value="osm">Streets</option>
                    <option value="aerial">Aerial</option>
                    <option value="none">None</option>
                  </select>
                </div>
              </div>
            </GridWindow>
          </div>
        </ReactGridLayout>
      </div>
    </>
  );
};

export default HomeAirport;
